// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `code[class*="language-"],
pre[class*="language-"] {
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  color: #eee;
  background: #2f2f2f;
  font-family: Roboto Mono, monospace;
  font-size: 1em;
  line-height: 1.5em;

  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;

  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

code[class*="language-"]::-moz-selection,
pre[class*="language-"]::-moz-selection,
code[class*="language-"] ::-moz-selection,
pre[class*="language-"] ::-moz-selection {
  background: #363636;
}

code[class*="language-"]::selection,
pre[class*="language-"]::selection,
code[class*="language-"] ::selection,
pre[class*="language-"] ::selection {
  background: #363636;
}

:not(pre) > code[class*="language-"] {
  white-space: normal;
  border-radius: 0.2em;
  padding: 0.1em;
}

pre[class*="language-"] {
  overflow: auto;
  position: relative;
  margin: 0.5em 0;
  padding: 1.25em 1em;
}

.language-css > code,
.language-sass > code,
.language-scss > code {
  color: #fd9170;
}

[class*="language-"] .namespace {
  opacity: 0.7;
}

.token.atrule {
  color: #c792ea;
}

.token.attr-name {
  color: #ffcb6b;
}

.token.attr-value {
  color: #a5e844;
}

.token.attribute {
  color: #a5e844;
}

.token.boolean {
  color: #c792ea;
}

.token.builtin {
  color: #ffcb6b;
}

.token.cdata {
  color: #80cbc4;
}

.token.char {
  color: #80cbc4;
}

.token.class {
  color: #ffcb6b;
}

.token.class-name {
  color: #f2ff00;
}

.token.comment {
  color: #616161;
}

.token.constant {
  color: #c792ea;
}

.token.deleted {
  color: #ff6666;
}

.token.doctype {
  color: #616161;
}

.token.entity {
  color: #ff6666;
}

.token.function {
  color: #c792ea;
}

.token.hexcode {
  color: #f2ff00;
}

.token.id {
  color: #c792ea;
  font-weight: bold;
}

.token.important {
  color: #c792ea;
  font-weight: bold;
}

.token.inserted {
  color: #80cbc4;
}

.token.keyword {
  color: #c792ea;
}

.token.number {
  color: #fd9170;
}

.token.operator {
  color: #89ddff;
}

.token.prolog {
  color: #616161;
}

.token.property {
  color: #80cbc4;
}

.token.pseudo-class {
  color: #a5e844;
}

.token.pseudo-element {
  color: #a5e844;
}

.token.punctuation {
  color: #89ddff;
}

.token.regex {
  color: #f2ff00;
}

.token.selector {
  color: #ff6666;
}

.token.string {
  color: #a5e844;
}

.token.symbol {
  color: #c792ea;
}

.token.tag {
  color: #ff6666;
}

.token.unit {
  color: #fd9170;
}

.token.url {
  color: #ff6666;
}

.token.variable {
  color: #ff6666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/CodeField/style.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;;EAElB,gBAAgB;EAChB,cAAc;EACd,WAAW;;EAEX,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  color: #eee;\n  background: #2f2f2f;\n  font-family: Roboto Mono, monospace;\n  font-size: 1em;\n  line-height: 1.5em;\n\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\n\ncode[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection {\n  background: #363636;\n}\n\ncode[class*=\"language-\"]::selection,\npre[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection,\npre[class*=\"language-\"] ::selection {\n  background: #363636;\n}\n\n:not(pre) > code[class*=\"language-\"] {\n  white-space: normal;\n  border-radius: 0.2em;\n  padding: 0.1em;\n}\n\npre[class*=\"language-\"] {\n  overflow: auto;\n  position: relative;\n  margin: 0.5em 0;\n  padding: 1.25em 1em;\n}\n\n.language-css > code,\n.language-sass > code,\n.language-scss > code {\n  color: #fd9170;\n}\n\n[class*=\"language-\"] .namespace {\n  opacity: 0.7;\n}\n\n.token.atrule {\n  color: #c792ea;\n}\n\n.token.attr-name {\n  color: #ffcb6b;\n}\n\n.token.attr-value {\n  color: #a5e844;\n}\n\n.token.attribute {\n  color: #a5e844;\n}\n\n.token.boolean {\n  color: #c792ea;\n}\n\n.token.builtin {\n  color: #ffcb6b;\n}\n\n.token.cdata {\n  color: #80cbc4;\n}\n\n.token.char {\n  color: #80cbc4;\n}\n\n.token.class {\n  color: #ffcb6b;\n}\n\n.token.class-name {\n  color: #f2ff00;\n}\n\n.token.comment {\n  color: #616161;\n}\n\n.token.constant {\n  color: #c792ea;\n}\n\n.token.deleted {\n  color: #ff6666;\n}\n\n.token.doctype {\n  color: #616161;\n}\n\n.token.entity {\n  color: #ff6666;\n}\n\n.token.function {\n  color: #c792ea;\n}\n\n.token.hexcode {\n  color: #f2ff00;\n}\n\n.token.id {\n  color: #c792ea;\n  font-weight: bold;\n}\n\n.token.important {\n  color: #c792ea;\n  font-weight: bold;\n}\n\n.token.inserted {\n  color: #80cbc4;\n}\n\n.token.keyword {\n  color: #c792ea;\n}\n\n.token.number {\n  color: #fd9170;\n}\n\n.token.operator {\n  color: #89ddff;\n}\n\n.token.prolog {\n  color: #616161;\n}\n\n.token.property {\n  color: #80cbc4;\n}\n\n.token.pseudo-class {\n  color: #a5e844;\n}\n\n.token.pseudo-element {\n  color: #a5e844;\n}\n\n.token.punctuation {\n  color: #89ddff;\n}\n\n.token.regex {\n  color: #f2ff00;\n}\n\n.token.selector {\n  color: #ff6666;\n}\n\n.token.string {\n  color: #a5e844;\n}\n\n.token.symbol {\n  color: #c792ea;\n}\n\n.token.tag {\n  color: #ff6666;\n}\n\n.token.unit {\n  color: #fd9170;\n}\n\n.token.url {\n  color: #ff6666;\n}\n\n.token.variable {\n  color: #ff6666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
